<div class="relative">
  <div class="flex flex-col">
    <label class="ml-2 text-xs font-semibold text-lightText">Bevorzugter Vertragspartner</label>
    <input
      #inputElement
      type="text"
      [formControl]="dealerControl"
      placeholder="Name, Straße, Postleitzahl oder Ort eingeben"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInputChange($event)"
      autocomplete="off"
      class="w-full p-2 h-[41px] placeholder:text-sm rounded-xl placeholder:md:text-left focus:outline-none border border-lighterText"
    />
  </div>

  @if (dropdownVisible) {
    <ul class="absolute z-10 mt-1 max-h-60 w-full overflow-auto bg-white border border-gray-300 rounded shadow-lg">
      @for (dealer of filteredDealers; track dealer.dealerNumber) {
        <li
          (mousedown)="$event.preventDefault()"
          (click)="selectDealer(dealer)"
          class="cursor-pointer px-3 py-2 hover:bg-lighterText hover:text-white [&:hover>div]:text-white"
        >
          <div class="font-semibold">{{ dealer.name }}</div>
          <div class="text-xs text-gray-600">{{ dealer.street }}, {{ dealer.postcode }} {{ dealer.city }}</div>
        </li>
      }
      @if (noResults) {
        <li class="px-3 py-2">Kein Ergebnis</li>
      }
    </ul>
  }
</div>
